module.exports = __webpack_public_path__ + "img/edit 1.e86dacc3.svg";